<form (keyup.enter)="submit()" [formGroup]="form">
  <div class="input-row-name">
    <gl-input-container class="input">
      <input formControlName="name" normal-input placeholder="name" type="text" data-ctx="input-name" />
    </gl-input-container>
  </div>
  <div class="dimensions">
    <div [glPremium]="true" class="titlePart">
      @if (typeLoadingSpace === 1) {
        <span>{{ 'semi_trailer' | translate }}</span>
      }
      @if (typeLoadingSpace === 2 && !isSet()) {
        <span>{{ 'container' | translate }}</span>
      }
      @if (typeLoadingSpace === 2 && isSet()) {
        <span>{{ 'container' | translate }} 1</span>
      }
      @if (typeLoadingSpace === 3 && !isSet()) {
        <span>{{ 'space' | translate }}</span>
      }
      @if (typeLoadingSpace === 3 && isSet()) {
        <span>{{ 'space' | translate }} 1</span>
      }
    </div>
    <div class="input-row" formGroupName="firstPart">
      <gl-input-container [units]="'length'" class="input">
        <input
          [numericType]="'float'"
          formControlName="length"
          normal-input
          placeholder="length"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'" class="input">
        <input
          [numericType]="'float'"
          formControlName="width"
          normal-input
          placeholder="width"
          type="text"
          />
      </gl-input-container>
      <gl-input-container [units]="'length'" class="input">
        <input
          [numericType]="'float'"
          formControlName="height"
          normal-input
          placeholder="height"
          type="text"
          />
      </gl-input-container>
    </div>
    <div class="input-row" formGroupName="firstPart">
      <gl-input-container [units]="'weight'" class="input">
        <input
          [numericType]="'float'"
          formControlName="limit"
          normal-input
          placeholder="limit"
          type="text"
        /></gl-input-container>
        <gl-select class="input" formControlName="trailerLoadingSide" placeholder="loading">
          <gl-option [value]="'back'" label="{{ 'back_side' | translate }}"></gl-option>
          <gl-option [value]="'right'" label="{{ 'right_side' | translate }}"></gl-option>
          <gl-option [value]="'left'" label="{{ 'left_side' | translate }}"></gl-option>
          <gl-option [value]="'top'" label="{{ 'top_side' | translate }}"></gl-option>
        </gl-select>
        @if (!changeType) {
          <gl-input-container class="input">
            <input
              [numericType]="'float'"
              formControlName="quantity"
              min="1"
              number-input
              placeholder="quantity"
              type="number"
              />
          </gl-input-container>
        }
      </div>
      @if (isEdit) {
        <div class="buttonRow">
          @if (isFormChanged && !isMyLoadingSpace) {
            <gl-icon-checkbox
              [checkboxFormGroup]="saveLoadingForm"
              [tooltipInfo]="'save_info'"
              [controlName]="'remember'"
              [iconName]="'saveIcon'"
            ></gl-icon-checkbox>
          }
          @if ((changeType && !isLoadingSpaceEquel()) || areStopsChanged()) {
            <div class="saveInfo">
              {{ 'save_information' | translate }}
            </div>
          }
          <button
            data-ctx="button-submit"
            (click)="submit()"
            outline-button
            type="submit"
            [class.saveButton]="(changeType && !isLoadingSpaceEquel()) || areStopsChanged()"
            >
            @if (isMyLoadingSpace || changeType) {
              {{ 'save' | translate }}
            }
            @if (!isMyLoadingSpace && !changeType) {
              {{ 'add' | translate }}
            }
          </button>
          @if (!hideDelete) {
            <button
              (click)="changeType ? emitDeleteLoadingSpace() : resetForm()"
              outline-icon-button
              type="reset"
              >
              <gl-icon name="delete"></gl-icon>
            </button>
          }
          <button (click)="reload()" outline-icon-button type="button">
            <gl-icon name="startArrangement"></gl-icon>
          </button>
        </div>
      }
    </div>
  </form>
